import { from, of } from "rxjs"
import { ofType } from "redux-observable"
import { push } from "connected-react-router"

import { switchMap, catchError } from "rxjs/operators"
import {
    fetchGeneralPlacementsRequestsSuccess,
    createNewRequestsSuccess,
    fetchGeneralPlacemetRequestDetailsSuccess,
    fetchGeneralPlacemetAllDetails,
    fetchDetailOptionsSuccess,
    SendEmailNotificationSuccess,
    ClearStateData,
} from "./actions"

import { hideLoader } from "../loader/actions"
import * as errorActions from "../error/actions"

import generalPlacementsApi from "../../api/generalPlacements-api"
import visibilityApi from "../../api/visibility-api"
import * as types from "./actionTypes"

export function fetchAllRequests(action$) {
    return action$.pipe(
        ofType(types.FETCH_ALL_REQUESTS),
        switchMap((action) =>
            from(generalPlacementsApi.getAllRequests(action.payload)).pipe(
                switchMap((requestsData) =>
                    of(fetchGeneralPlacementsRequestsSuccess(requestsData))
                ),
                switchMap((requestsData) =>
                    requestsData.payload.length > 0
                        ? from(
                              generalPlacementsApi.getRequestDetails({
                                  data: requestsData.payload,
                                  isfirstRequest: true,
                              })
                          ).pipe(
                              switchMap((requestDetailsData) =>
                                  of(
                                      fetchGeneralPlacemetRequestDetailsSuccess(
                                          {
                                              requestsData:
                                                  requestsData.payload,
                                              requestDetails:
                                                  requestDetailsData,
                                          }
                                      ),
                                      hideLoader()
                                  )
                              ),
                              catchError((error) =>
                                  of(
                                      push("/error"),
                                      errorActions.setError(error),
                                      hideLoader()
                                  )
                              )
                          )
                        : of(ClearStateData(), hideLoader())
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}
export function fetchRequestDetails(action$) {
    return action$.pipe(
        ofType(types.FETCH_REQUEST_DETAILS),
        switchMap((requestsData) =>
            from(
                generalPlacementsApi.getRequestDetails({
                    data: requestsData.payload,
                    isfirstRequest: false,
                })
            ).pipe(
                switchMap((data) =>
                    of(fetchGeneralPlacemetAllDetails(data), hideLoader())
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}
export function crateNewRequests(action$) {
    return action$.pipe(
        ofType(types.CREATE_NEW_REQUESTS),
        switchMap((action) =>
            from(generalPlacementsApi.createNewRequest(action.payload)).pipe(
                switchMap((data) =>
                    of(
                        createNewRequestsSuccess({
                            ...data,
                            emails: action.payload.emails,
                        }),
                        hideLoader()
                    )
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function fetchDetailsOptions(action$) {
    return action$.pipe(
        ofType(types.FETCH_DETAILS_VALUE_OPTIONS),
        switchMap(() =>
            from(visibilityApi.getShipperFilterValues()).pipe(
                switchMap((data) =>
                    of(fetchDetailOptionsSuccess(data), hideLoader())
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}
export function sendEmailNotification(action$) {
    return action$.pipe(
        ofType(types.CREATE_NEW_REQUESTS_SUCCESS),
        switchMap((action) =>
            from(
                generalPlacementsApi.sendEmailNotification(action.payload)
            ).pipe(
                switchMap(() => of(SendEmailNotificationSuccess())),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}
